import { render } from "./ProfileContainer.vue?vue&type=template&id=2558010c&scoped=true"
import script from "./ProfileContainer.vue?vue&type=script&lang=js"
export * from "./ProfileContainer.vue?vue&type=script&lang=js"

import "./ProfileContainer.vue?vue&type=style&index=0&id=2558010c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2558010c"]])

export default __exports__